import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import arrowUp from '@icons/down.svg';
import arrowDown from '@icons/up.svg';

const SidebarItem = ({ item, selectedItemId, handleSideBarClick, activeUrl, customClass = '' }) => {
    const { collapsedForm } = useSelector((state) => state.sidebar);
    const [expand, setExpand] = useState(false);

    return (
        <>
            <Link
                to={item.linkTo}
                className={`sidebar-item ${customClass} ${item.id === selectedItemId || item?.allowedLinks?.includes(activeUrl) ? 'active-sidebar-item' : 'inactive-sidebar-item'} ${
                    item.name === 'Account Settings' ? 'account-settings-class' : ''
                }`}
                style={item.name === 'Account Settings' ? { padding: '16px' } : {}}
                onClick={() => {
                    if (item?.type === 'MainItem') {
                        setExpand(!expand);
                    } else {
                        setExpand(true);
                    }
                    handleSideBarClick(item);
                }}
            >
                {item.iconLight && <img src={item.iconLight} className="sidebar-item-icon" alt="sidebar-icon" />}
                <span
                    className={`sidebar-item-text ${collapsedForm ? 'hide-sidebar-item-text' : 'show-sidebar-item-text'}`}
                >
                    {item.name}
                </span>
                {item.type === 'MainItem' && (
                    <img
                        src={expand ? arrowDown : arrowUp}
                        className="sidebar-item-icon m-auto margin-right-0"
                        alt="sidebar-icon"
                    />
                )}
            </Link>
            {expand &&
                item.type === 'MainItem' &&
                item.subItems?.map((subItem) => (
                    <>
                        <Link
                            to={subItem.linkTo}
                            className={`sub-item ${customClass} ${subItem.id === selectedItemId ? 'active-sidebar-item' : 'inactive-sidebar-item'}`}
                            onClick={() => handleSideBarClick(subItem)}
                        >
                            {subItem.iconLight && (
                                <img src={subItem.iconLight} className="sidebar-item-icon" alt="sidebar-icon" />
                            )}
                            <span
                                className={`sidebar-item-text ${collapsedForm ? 'hide-sidebar-item-text' : 'show-sidebar-item-text'}`}
                            >
                                {subItem.name}
                            </span>
                        </Link>
                    </>
                ))}
        </>
    );
};

export default SidebarItem;
